import type Result from 'true-myth/result';

import type { ValidatingHttpFetcherWithBaseUrl } from '~/shared/validating-http-fetcher';

import type { CompanyProfile } from './company-profile';
import { companyProfileSchema } from './company-profile';

export type FetchCompanyProfile = () => Promise<Result<CompanyProfile, unknown>>;

export const createFetchCompanyProfile = (dependencies: {
    readonly validatingCobrainerApiFetcher: ValidatingHttpFetcherWithBaseUrl;
}): FetchCompanyProfile => {
    const { validatingCobrainerApiFetcher } = dependencies;

    return () => {
        return validatingCobrainerApiFetcher.get(companyProfileSchema, {
            pathname: `/company-profile`,
        });
    };
};
